import { Component, input, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ErrorCardComponent } from '../error-card/error-card.component';

@Component({
  selector: 'app-data-unavailable-card',
  imports: [RouterModule, ErrorCardComponent],
  templateUrl: './data-unavailable-card.component.html',
})
export class DataUnavailableCardComponent {
  readonly entityLabel = input.required<string>();
  readonly selectedDate = input<string>();
  readonly backRoute = input<string | undefined>();
  readonly backQueryParams = input<Record<string, string | null>>();
  readonly backClick = output();
}
